// @ts-nocheck
import * as React from 'react';
import Stack from 'molecules/stack/stack';
import Sheet from 'atoms/sheet/sheet';
import SheetBody from 'atoms/sheet/sheetBody/sheetBody';
import { useNavigate } from 'react-router-dom';
import { getEnabledOptions, isLoading } from './selectors';
import { useDispatch, useSelector } from 'react-redux';
import AppSettingMenu from './appSettingMenu/appSettingMenu';
import * as sagaActions from './sagaActions';
import StackItem from 'molecules/stackItem/stackItem';
import Loader from 'atoms/loader';
import PageLayout from 'templates/pageLayout';

export type OptionTypes = {
	title: string;
	description: string;
	buttonText: string;
	itemIdentifier: string;
};

const Settings: React.FunctionComponent = () => {
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const handleMasterDataButtonClick = (option) => {
		navigate(option.url);
	};

	const loading = useSelector((state) => isLoading(state, 'dashboard'));

	const options = useSelector((state) => getEnabledOptions(state));

	React.useEffect(() => {
		dispatch(sagaActions.getDashBoardData());
	}, [dispatch]);

	if (loading) {
		return (
			<PageLayout>
				<Stack>
					<StackItem isGrow isStretch align="center">
						<Loader />
					</StackItem>
				</Stack>
			</PageLayout>
		);
	}

	return (
		<Sheet className="sheet--page dashboard-page">
			<SheetBody>
				<Stack className="dashboard-card-wrapper dashboard-card-wrapper-setting">
					{options.map((option) => {
						return (
							<AppSettingMenu
								title={option.title}
								description={option.description}
								buttonText={option.buttonText}
								itemIdentifier={option.itemIdentifier}
								count={option.count}
								handleButtonClick={() => handleMasterDataButtonClick(option)}
							/>
						);
					})}

					{/* </InfiniteScroll> */}
				</Stack>
			</SheetBody>
		</Sheet>
	);
};
export default Settings;
